module.exports = __webpack_public_path__ + "static/media/pupil_app_url.98be9357.svg";